module.exports = __webpack_public_path__ + "static/media/nortek_logo.97d30ccf.svg";